import {atom} from "recoil";
import {Cart} from "../lib/model";
import apps, {SaleMode} from "../lib/apps";

export const cartState = atom<Cart>({
  key: "cartState",
  default: new Cart(SaleMode.UNKNOWN, null)
})
